import { useNavigate } from "react-router-dom";
import { ArrowLeft, Mail, Phone, CheckSquare } from "lucide-react";

const AboutFleetyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white" data-testid="about-fleety-page">
      {/* Top Spacer for mobile */}
      <div className="h-6 bg-white"></div>
      
      {/* Header */}
      <header className="bg-white px-4 py-4 shadow-sm sticky top-0 z-40">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <button 
            onClick={() => navigate("/home")}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100"
            data-testid="back-btn"
          >
            <ArrowLeft size={24} className="text-gray-700" />
          </button>
          <h1 className="text-xl font-bold text-gray-900">About Fleety</h1>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Main Content */}
        <div className="prose prose-gray max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">About Fleety</h1>
          
          <p className="text-gray-700 mb-4">
            Fleety is India's transparent, modern food delivery platform built to bring fairness back to the ecosystem. No hidden charges. No inflated prices. No unfair commissions.
          </p>
          
          <p className="text-gray-700 mb-4">
            Our mission is simple — keep menu prices original, reduce delivery costs, and ensure predictable earnings for partners. We believe food delivery should be honest, fast, and accessible to everyone.
          </p>
          
          <p className="text-gray-700 mb-8">
            Fleety is built in Bangalore with a deep focus on quality, transparency, and trust. Every part of the platform — from pricing to delivery to partner payouts — is designed to be clear, fair, and efficient.
          </p>

          {/* What We Stand For */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What We Stand For</h2>
          
          <ul className="space-y-3 mb-8">
            <li className="flex items-start gap-3">
              <CheckSquare size={20} className="text-[#3FA9F5] mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Transparent pricing</strong> — customers always see real menu prices.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <CheckSquare size={20} className="text-[#3FA9F5] mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Fair partner payouts</strong> — restaurants and riders earn more.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <CheckSquare size={20} className="text-[#3FA9F5] mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>No inflated fees</strong> — no unnecessary charges.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <CheckSquare size={20} className="text-[#3FA9F5] mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">
                <strong>Fast & reliable delivery</strong> — powered by local riders.
              </span>
            </li>
          </ul>

          {/* Our Vision */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h2>
          
          <p className="text-gray-700 mb-8">
            To build India's most trusted food delivery ecosystem where customers, restaurants, and riders feel respected and rewarded — with proof, not promises.
          </p>

          {/* Contact Us */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
          
          <div className="space-y-3 mb-8">
            <div className="flex items-center gap-3">
              <Mail size={20} className="text-[#3FA9F5]" />
              <a href="mailto:support@fleety.co.in" className="text-[#3FA9F5] hover:underline">
                support@fleety.co.in
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Phone size={20} className="text-[#3FA9F5]" />
              <a href="tel:+919845331817" className="text-[#3FA9F5] hover:underline">
                +91-98453 31817
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutFleetyPage;
